import { useContext } from 'react';
import { S as SubmitErrorMessageContext } from '../contexts/SubmitErrorMessage/SubmitErrorMessageContext-CpbYOZ01.js';

const useSubmitErrorMessage = () => {
  const submitErrorMessage = useContext(SubmitErrorMessageContext);
  return submitErrorMessage;
};

export { useSubmitErrorMessage as u };
//# sourceMappingURL=useSubmitErrorMessage-BKr3iztZ.js.map
